
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TextareaWithLabel extends Vue {
    @Prop({ default: '' }) labelTranslationKey!: string
    @Prop({ default: '' }) placeholderTranslationKey!: string
    @Prop() value!: string
    @Prop() setter!: (value: unknown) => void

    get inputValue (): string {
        return this.value
    }

    set inputValue (value) {
        this.setter(value)
    }

    handleBlur (event: Event) {
        this.$emit('blur', event)
    }
}
